import { Send } from "@mui/icons-material";
import { Box, TextField, IconButton } from "@mui/material";
import Comments from "./Comments";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import type { RootState } from "../store";
import axiosService from "../utils/axios";
import type { IComment } from "../types/comment";
import type { IRecipeSetComment } from "./SavedRecipe";

interface IRecipeComments {
    refId: string;
    comments: IComment[];
    setComments: IRecipeSetComment;
}

const RecipeComments: React.FC<IRecipeComments> = ({ refId, comments, setComments }) => {
    const authState = useSelector((state: RootState) => state.auth);

    const [message, setMessage] = useState("");
    const [localComments, setLocalComments] = useState<IComment[]>(comments ?? []);

    const handleSendMessage = useCallback(() => {
        axiosService.post(`${process.env.REACT_APP_API_URL}/recipes/comment/create`, { content: message, refId: refId }).then((res) => {
            const newComment = {
                content: res.data.body.content,
                createdAt: res.data.body.createdAt,
                user: res.data.body.user,
                likes: res.data.body.likes,
                _id: res.data.body._id,
            };

            setLocalComments((prev) => [
                ...prev,
                {
                    content: res.data.body.content,
                    createdAt: res.data.body.createdAt,
                    user: res.data.body.user,
                    likes: res.data.body.likes,
                    _id: res.data.body._id,
                },
            ]);

            setComments("newComment", [...localComments, newComment]);
            setMessage("");
        });
    }, [localComments, message, refId, setComments]);

    return (
        <Box>
            <Box
                sx={{
                    padding: 2,
                    borderBottom: "1px solid #ddd",
                    display: "flex",
                    alignItems: "flex-end",
                    gap: 1,
                    backgroundColor: "#fff",
                }}
            >
                <TextField
                    disabled={!authState.account}
                    fullWidth
                    multiline
                    maxRows={4}
                    placeholder={!!authState.account ? "Write a comment..." : "Log in to comment!"}
                    variant="outlined"
                    size="small"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    sx={{
                        flexGrow: 1,
                        backgroundColor: "#f9f9f9",
                        borderRadius: 2,
                    }}
                />
                <IconButton color="primary" onClick={handleSendMessage} disabled={!message.trim()}>
                    <Send />
                </IconButton>
            </Box>

            <Box sx={{ p: 4 }}>
                <Comments comments={localComments} type="Recipe" setData={setComments} />
            </Box>
        </Box>
    );
};

export default RecipeComments;
